const getters = {

  getBreadcrumb: state => state.app.breadcrumb,
  getUser: state => state.app.user,
  getActiveIndex: state => state.app.activeIndex,
  getActiveUrl: state => state.app.activeUrl,
  getDepartmentId: state => state.app.departmentId,
  roles: state => state.user.roles
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js